import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoggerService } from '../service/logger.service';
import { of, Observable, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { appConfig, AuthGaurdService } from '../service/auth-gaurd.service';
import { ReportModel } from './report.model';
import { catchError, map } from 'rxjs/operators';
import { tap } from 'rxjs/operators';
import { ProcessModel } from './process.model';

@Injectable({
    providedIn: 'root'
})

export class ProcessService {

    private host = environment.apiUrl + "reportframework/reportprocess";
    public loggedinUser: string = '';
    public processModel = new ProcessModel('', 0, 0, '', '', '', null, '', null,'','','','','','','','');
    myDetailsSet = new Set<string>();

    constructor(private http: HttpClient,
        private logger: LoggerService, private authGaurdService: AuthGaurdService) {
    }

    public getReports(): Observable<ProcessModel[]> {
        return this.http.get<ProcessModel[]>(`${this.host}/getprocessreport`);
    }

    public getReportDetails(): Observable<ProcessModel[]> {
        return this.http.get<ProcessModel[]>(`${this.host}/getreportdetails`);
    }
}


